<div class="no-data-container">
  <img class="product-img" src="/assets/e-commerce/icons/73.webp" />
  <p class="no-data-text">
    {{ "No data available" | transloco }}
  </p>
  <button class="btn btn-add" routerLink="/search" style="margin-bottom: 10px;">
    {{ "search again" | transloco}}
  </button>
</div>